import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
const control = 'w-full rounded-xl border border-line bg-white px-4 py-3 text-[15px] text-ink placeholder:text-ink-faint transition-colors duration-200 ease-smooth hover:border-ink/25 focus:border-accent focus:outline-none';
interface BaseProps {
  label: string;
  hint?: string;
  required?: boolean;
  className?: string;
  id: string;
}
function Wrapper({
  label,
  hint,
  required,
  id,
  className = '',
  children
}: BaseProps & {
  children: React.ReactNode;
}) {
  return <div className={className} data-id="element-169" data-mp="d1ibe2jd0cxt">
      <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-ink" data-id="element-170" data-mp="d0p2auwxhbci">
        {label}
        {required && <span className="ml-1 text-accent" data-id="element-171" data-mp="msv1aollkt17">*</span>}
      </label>
      {children}
      {hint && <p className="mt-1.5 text-xs text-ink-muted" data-id="element-172" data-mp="mupgrne3nsxw">{hint}</p>}
    </div>;
}
export function TextField({
  label,
  hint,
  required,
  className,
  id,
  ...rest
}: BaseProps & React.InputHTMLAttributes<HTMLInputElement>) {
  return <Wrapper label={label} hint={hint} required={required} id={id} className={className} data-id="element-173" data-mp="ybpmp4lbl8mw">
      <input id={id} required={required} className={control} {...rest} data-id="element-174" data-mp="tbth50wz5958" />
    </Wrapper>;
}
export function TextArea({
  label,
  hint,
  required,
  className,
  id,
  rows = 5,
  ...rest
}: BaseProps & React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <Wrapper label={label} hint={hint} required={required} id={id} className={className} data-id="element-175" data-mp="ke10ntfinvg9">
      <textarea id={id} rows={rows} required={required} className={`${control} resize-y`} {...rest} data-id="element-176" data-mp="1h3rxhzba5up8" />
    </Wrapper>;
}
export function SelectField({
  label,
  hint,
  required,
  className,
  id,
  options,
  ...rest
}: BaseProps & React.SelectHTMLAttributes<HTMLSelectElement> & {
  options: {
    value: string;
    label: string;
  }[];
}) {
  return <Wrapper label={label} hint={hint} required={required} id={id} className={className} data-id="element-177" data-mp="1ztgnde09ykxq">
      <div className="relative" data-id="element-178" data-mp="1v1gg10hvkpr4">
        <select id={id} required={required} className={`${control} appearance-none pr-10`} {...rest} data-id="element-179" data-mp="1v0f64zcli9az">
          {options.map(option => <option key={option.value} value={option.value} data-id="element-180" data-mp="3u8dq7s2d0vzv">
              {option.label}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-faint" aria-hidden="true" data-id="element-181" data-mp="3fizi0naiskm2" />
      </div>
    </Wrapper>;
}